module.exports = __webpack_public_path__ + "img/avatar-user-here.0393c8ba.png";